// Adapted from https://simple.wikipedia.org/wiki/List_of_fruits
export default [
  'Akee',
  'Apple',
  'Apricot',
  'Avocado',
  'Açaí',
  'Banana',
  'Bilberry',
  'Blackberry',
  'Blackcurrant',
  'Blueberry',
  'Boysenberry',
  'Cantaloupe',
  'Cherimoya',
  'Cherry',
  'Chico',
  'Clementine',
  'Cloudberry',
  'Coconut',
  'Crabapple',
  'Cranberry',
  'Cucumber',
  'Currant',
  'Damson',
  'Durian',
  'Elderberry',
  'Feijoa',
  'Fig',
  'Goji',
  'Gooseberry',
  'Grape',
  'Grapefruit',
  'Guava',
  'Honeyberry',
  'Honeydew',
  'Huckleberry',
  'Jabuticaba',
  'Jackfruit',
  'Jambul',
  'Jostaberry',
  'Jujube',
  'Juniper',
  'Kiwano',
  'Kiwi',
  'Kumquat',
  'Lemon',
  'Lime',
  'Longan',
  'Loquat',
  'Lychee',
  'Mandarine',
  'Mango',
  'Mangosteen',
  'Marion',
  'Melon',
  'Mulberry',
  'Nance',
  'Nectarine',
  'Olive',
  'Orange',
  'Papaya',
  'Peach',
  'Pear',
  'Persimmon',
  'Pineapple',
  'Pineberry',
  'Pitaya',
  'Plantain',
  'Plum',
  'Plumcot',
  'Pomegranate',
  'Pomelo',
  'Prune',
  'Pumpkin',
  'Quince',
  'Raisin',
  'Rambutan',
  'Raspberry',
  'Salak',
  'Salal',
  'Salmonberry',
  'Sapote',
  'Satsuma',
  'Soursop',
  'Strawberry',
  'Surinam',
  'Tamarillo',
  'Tamarind',
  'Tangerine',
  'Tomato',
  'Watermelon',
  'Yuzu',
  'Zucchini',
]
